// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalInstance } from "./app/auth/authConfig"; // MSAL instance
import Login from "./app/auth/SigninWidget"; // Your login component
import useAutoLogout from "./app/auth/AutoLogout";
import Output from "./pages/Output/Output";
import Details from "./pages/Details/Details";
import Anonymized from "./pages/Anonymized/Anonymized";
import AIEmailIntegration from "./pages/AIEmailIntegration/AIEmailIntegration";
import RetailDisplayChecker from "./pages/RetailDisplayChecker/RetailDisplayChecker";

const App = () => {
  useAutoLogout(); // Automatically logs out after 5 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} /> {/* Home route */}
          {/* <Route path="/fileoutput" element={<Output />} />  */}
          <Route path="/details" element={<Details />} /> {/* Home route */}
          <Route path="/Anonymized" element={<Anonymized />} /> {/* Home route */}
          <Route path="/email-integrations" element={<AIEmailIntegration />} /> {/* Home route */}
          <Route path="/retailDisplayChecker" element={<RetailDisplayChecker />} /> {/* Home route */}


        </Routes>
      </Router>
    </MsalProvider>
  );
};

export default App;
